import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import storage, { clearAllLocalAppData } from "./utils/storage";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initTooltips } from "./utils/tooltip";

// export const url = "http://localhost:3000";

// NOTE: `clearAllLocalAppData()` can unregister service workers and
// clear caches. Do NOT call it on every app load if you want persistent
// offline support. Call it explicitly on logout or when the user requests
// a full reset.

// NOTE: Pages will fetch data from server via their own useEffect hooks
// We do NOT pre-populate localStorage here to avoid temporary/cached data

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();

// Activate modern tooltip system — migrates native title -> data-tooltip everywhere
try {
  initTooltips();
} catch (_) {}

// Register the service worker to enable PWA offline support and installability.
// In development (localhost) the worker will not be registered.
serviceWorkerRegistration.register();

// Global handler: when a number input is focused and its current visible value is exactly "0",
// clear it so users see an empty field (no default 0). This attempts to update both
// uncontrolled and React-controlled inputs by using the native value setter and
// dispatching an input event so React's onChange/controlled state can pick it up.
document.addEventListener("focusin", (e) => {
  try {
    const t = e.target;
    if (t && t.tagName === "INPUT" && t.type === "number") {
      if (t.value === "0") {
        const descriptor = Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype,
          "value",
        );
        if (descriptor && descriptor.set) {
          descriptor.set.call(t, "");
          t.dispatchEvent(new Event("input", { bubbles: true }));
        } else {
          // Fallback: direct assignment
          t.value = "";
          t.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }
    }
  } catch (err) {
    // Non-fatal; don't break app if this fails
    // console.warn('number-input focus handler error', err);
  }
});
